import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import DashboardTable from './components/DashboardTable';
import MasterView from './components/MasterView';
import TMCTable from './components/TmcTable';
import Login from './components/Login';

import './App.css';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('bcd_token');
  return token ? children : <Navigate to="/login" replace />;
};

// In AppContent component, get user email and check domain
function AppContent() {
  const location = useLocation();
  const showSidebar = location.pathname !== '/login';

  const userEmail = localStorage.getItem('bcd_email') || ''; // Adjust based on your auth storage
  const domain = userEmail.split('@')[1] || '';
  const isKgrpUser = domain === 'kgrp.in';

  return (
    <div className="app-container">
      {showSidebar && <Sidebar isKgrpUser={isKgrpUser} />}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/Login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardTable />
              </PrivateRoute>
            }
          />
          <Route
            path="/tmc/:tmcName"
            element={
              <PrivateRoute>
                <TMCTable />
              </PrivateRoute>
            }
          />
          {/* Only add this route if user is from kgrp.in */}
          {isKgrpUser && (
            <Route
              path="/master-view"
              element={
                <PrivateRoute>
                  <MasterView />
                </PrivateRoute>
              }
            />
          )}
        </Routes>
      </div>
    </div>
  );
}


function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
